import {
  mapGetters,
} from 'vuex';

import {
  TireSizeSelectorItem,
} from '@/components';

export default {
  name: 'TireSizeSelector',
  components: {
    [TireSizeSelectorItem.name]: TireSizeSelectorItem,
  },
  props: {
    type: '',
  },
  data: () => ({}),
  computed: {
    ...mapGetters('appointment', {
      tireSizes: 'getTireSizes',
      tireType: 'getTireType',
      tireLocations: 'getTireLocations',
    }),
    ...mapGetters('garage', {
      tireCodes: 'getTireCodes',
    }),
    needsFrontAxisTires() {
      if (this.type === 'tpp') {
        return true;
      }
      return this.needsTire('t1l1') || this.needsTire('t1r1');
    },
    needsBackAxisTires() {
      if (this.type === 'tpp') {
        return true;
      }
      return this.needsTire('t2l2') || this.needsTire('t2l1') || this.needsTire('t2r1') || this.needsTire('t2r2');
    },
  },
  methods: {
    needsTire(location) {
      // 0/1/2/3 -> Disabled/Not active/Active/Stock
      return this.tireLocations[`${location}`][`${this.tireType}Stock`] === 1 || this.tireLocations[`${location}`][`${this.tireType}Stock`] === 2;
    },
  },
};
